// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3Gob1","header":"Messages_header__1xCZF"};